import useIsSuperAdmin from '../../helpers/useIsSuperAdmin';

// Renders children only for super admins. Kept separate from SuperAdminBadge/
// SuperAdminArea so those can skip the Redux read entirely when a caller passes
// an explicit `show` flag — some call sites render without a store Provider in
// tests, and hooks cannot be called conditionally.
const SuperAdminGate = ({ children }) => {
  const isSuperAdmin = useIsSuperAdmin();
  return isSuperAdmin ? children : null;
};

export default SuperAdminGate;
